import(/* webpackMode: "eager", webpackExports: ["GoogleOAuthButton"] */ "/vercel/path0/apps/main-app/src/app/auth/_components/GoogleOAuthButton.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["makeApolloClient"] */ "/vercel/path0/apps/main-app/src/lib/apolloWrapper.ts");
;
import(/* webpackMode: "eager" */ "/vercel/path0/node_modules/next/dist/client/link.js");
